import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
} from '@/components/_common';
import { Col, Form, Modal, ModalProps, Row } from 'antd';
import { useEffect } from 'react';

export interface WriteOffFormValues {
  companyId: number;
}

type Props = Omit<ModalProps, 'onCancel'> & {
  onCancel: () => void;
  companyId?: number;
  onCallback: () => void;
  loading?: boolean;
};

export default function BankSlipWriteOffModal({
  open,
  onCancel,
  companyId,
  onCallback,
  loading,
}: Props) {
  const [form] = Form.useForm<WriteOffFormValues>();

  const handleOk = async () => {
    await onCallback();

    form.resetFields();

    onCancel();
  };

  useEffect(() => {
    if (companyId) {
      form.setFieldValue('companyId', companyId);
    }
  }, [open]);

  return (
    <Modal
      width={400}
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      title="Solicitação de baixa"
      cancelText="Cancelar"
      okText="Enviar"
      confirmLoading={loading}
    >
      <Form form={form}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <FloatingFormItem label="Empresa" name="companyId">
              <CompaniesInfiniteSelectField disabled />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
